import { useState, useLayoutEffect, useEffect } from "react";

type Breakpoint = "xs" | "sm" | "md" | "lg";

const getWindowDimensions = () => {
    const { innerWidth: width, innerHeight: height } =
        typeof window === "undefined" ? { innerWidth: undefined, innerHeight: undefined } : window;

    const getBreakpoint = (): { name: Breakpoint; index: number } => {
        if (width <= 575.98) return { name: "xs", index: 0 };
        if (width <= 767.98) return { name: "sm", index: 1 };
        if (width <= 991.98) return { name: "md", index: 2 };
        return { name: "lg", index: 3 };
    };

    return {
        width,
        height,
        breakpoint: getBreakpoint().name,
        breakpointIndex: getBreakpoint().index,
    };
};

export const useWindowDimensions = () => {
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

    useLayoutEffect(() => {
        const handleResize = () => {
            setWindowDimensions(getWindowDimensions());
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return windowDimensions;
};

export default useWindowDimensions;
